import BlogThirtyContainer from "./container/BlogThirtyContainer";
export default BlogThirtyContainer;
